"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = passwordMatched;

function passwordMatched(value, allValues) {
  return value !== allValues.password ? {
    message: 'validation.password.mismatch'
  } : null;
}